export default {
	main: Date.parse('November 26 2019 19:30:00 GMT+0300'),
	article1: Date.parse('April 03 2019 20:00:00 GMT+0300'),
	article2: Date.parse('May 22 2019 20:00:00 GMT+0300'),
	article3: Date.parse('July 24 2019 20:00:00 GMT+0300'),
};
